function destroySelectize() {
  $('.selectize, .selectize-max1, .selectize-max2, .selectize-max3').each(function() {
    if (this.selectize) {
      this.selectize.destroy();
    }
  });
}

function initSelectize() {
  // Pequeño delay para asegurar que el DOM está completamente actualizado
  setTimeout(() => {
    destroySelectize();

    // Leer el valor seleccionado desde el atributo 'selected' de las options
    $('.selectize').each(function() {
      const $select = $(this);
      const selectedValue = $select.find('option[selected]').val() || $select.val();
      $select.selectize({
        items: selectedValue ? [selectedValue] : []
      });
    });

    $('.selectize-max3').each(function() {
      const $select = $(this);
      const selectedValues = $select.find('option[selected]').map(function() { return this.value; }).get();
      $select.selectize({
        maxItems: 3,
        items: selectedValues.length ? selectedValues : ($select.val() || [])
      });
    });

    $('.selectize-max1').each(function() {
      const $select = $(this);
      const selectedValue = $select.find('option[selected]').val() || $select.val();
      $select.selectize({
        maxItems: 1,
        items: selectedValue ? [selectedValue] : []
      });
    });

    $('.selectize-max2').each(function() {
      const $select = $(this);
      const selectedValues = $select.find('option[selected]').map(function() { return this.value; }).get();
      $select.selectize({
        maxItems: 2,
        items: selectedValues.length ? selectedValues : ($select.val() || [])
      });
    });
  }, 10);
}

// Destruir selectize antes de que Turbo guarde en caché
document.addEventListener("turbo:before-cache", destroySelectize);
document.addEventListener("turbo:load", initSelectize);
document.addEventListener("turbo:render", initSelectize);